import { AnalyticsContext } from '@carvana/eventable-clickstream';
import {
  useTrackClickEvent as useCommonTrackClickEvent,
  useTrackClickEvents as useCommonTrackClickEvents
} from '@carvana/merch-react-hooks';
import { datadogRum } from '@datadog/browser-rum';
import { useContext } from 'react';

export function useTrackClickEvent() {
  return useCommonTrackClickEvent(
    useContext(AnalyticsContext).trackEvent,
    datadogRum.addAction
  );
}

export function useTrackClickEvents() {
  return useCommonTrackClickEvents(
    useContext(AnalyticsContext).trackEvent,
    undefined,
    datadogRum.addAction
  );
}
